$(document).ready(function(){
  $('.product-form__item--quantity .quantity-select').each(function() {
    var spinner = $(this),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find('.adjust-plus'),
        btnDown = spinner.find('.adjust-minus'),
        min = input.attr('min'),
        max = input.attr('max');

    btnUp.click(function() {
      var oldValue = parseFloat(input.val());
      if (oldValue >= max) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue + 1;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
    });

    btnDown.click(function() {
      var oldValue = parseFloat(input.val());
      if (oldValue <= min) {
        var newVal = oldValue;
      } else {
        var newVal = oldValue - 1;
      }
      spinner.find("input").val(newVal);
      spinner.find("input").trigger("change");
    });

  });
  
  $('.grid_view').on('click',function(e) {
    $('.change-view a').removeClass('active');
    $(this).addClass('active');
    $('#grid_view').show();
    $('#list_view').hide();
  });
  $('.list_view').on('click',function(e) {
    $('.change-view a').removeClass('active');
    $(this).addClass('active');
    $('#grid_view').hide();
    $('#list_view').show();
  });
  
  /* $('.product-shop .grid__item').parent().each(function() {
    var height = 0,
        column = $(this).find('.grid__item'),
        imgHeight = 0,
    	imgColumn = $(this).find('.grid-view-item__image-wrapper');
    column.each(function() {
      if ($(imgColumn).height() > imgHeight) imgHeight = $(imgColumn).height();
      if ($(this).height() > height) height = $(this).height();
    });
    column.height(height);
    $(imgColumn).find('img').height(imgHeight);
    imgColumn.height(imgHeight);
  }); */
  
  var rightHeight = $('.right-section img').height()
  $('.left-section img').height(rightHeight);
  
  var section2Height = $('.section-second .block_half img').height()
  $('.block-head .text-center').height(section2Height);
  
  
});

$(document).ready(function(){
  
  var $active, $content, $links = $('#tabs').find('li');
  
  var hashLink = location.hash;
  if(hashLink != ''){
    // Hide the remaining content
    $('li').each(function(){
      $('.section-header h1').text('')
      $(this).removeClass('current');
      $('.tab-content').removeClass('current');
    });

    $('li').each(function(){
      var data_id = $(this).attr('data-tab');
      if('#'+data_id == hashLink){
        var text = $(this).html();
        console.log(text);
        $('.section-header h1').html(text);
        $(this).addClass('current');
        $('#tabsContent '+hashLink).addClass('current');
      }
    });

  }
  
  $('#tabs li').click(function(){
    var tab_id = $(this).attr('data-tab');
	console.log(tab_id);
    $('#tabs li').removeClass('current');
    $('.tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
    $('.section-header h1').html($(this).html());
  })
  
  $( "#accordion h3" ).addClass('accordion');
  $( "#accordion p" ).addClass('panel');
  
  $('.accordion').on('click', function(){
    $('.panel').hide();
    $('.accordion').removeClass('active');
    $(this).toggleClass('active');
    var isVisible = $(this).next().is(':visible');
    console.log(isVisible);
    if(isVisible == true){
      $(this).next().hide();
    }else{
      $(this).next().show();
    }
  });
  
  $('.owl-carousel').owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    navigation: true,
    nav:true,
    navText: ["<img src='//www.jesuslifts.com/cdn/shop/files/left_arrow.png?v=8038257731985133990'>","<img src='//www.jesuslifts.com/cdn/shop/files/right_arrow.png?v=10569635110679352862'>"],
    responsive:{
      0:{
        items:1,
        nav:true
      },
      420:{
        items:2,
        nav:true
      },
      520:{
      	items:3,
        nav:true
      },
      767:{
        items:4,
        nav:true,
      },
      767:{
       	items:5,
        nav:true,
      }
    }
  })
});